/**
 * timeOptions.jsx
 *
 * @Author: apple
 * @Date: 2018/6/14 01:31
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import Button from '../button';
import slideTo from '../util/slideTo';
import easyToMap from '../util/easyToMap';
/**
 * TimePanel
 * */
class TimePanel extends PureComponent {
  static propTypes = {
    /**
     * 更新时间回调函数
     * @params time: 所选时间
     * @return
     * */
    onValueChange: PropTypes.func,
    /**
     * 禁用小时
     * @return true为禁用 false为不禁用
     * */
    disabledHours: PropTypes.func,
    /**
     * 禁用分钟
     * @params selectHour:当前渲染小时
     * @return true为禁用 false为不禁用
     * */
    disabledMinutes: PropTypes.func,
    /**
     * 禁用秒
     * @params selectHour:当前所渲染小时, selectMinute:当前所渲染分钟
     * @return true为禁用 false为不禁用
     * */
    disabledSeconds: PropTypes.func,
    itemHeight: PropTypes.number,
  };

  static defaultProps = {
    prefixCls: 'ne-time-panel',
    itemHeight: 32,
  };

  componentDidMount() {
    const { value } = this.props;
    this.setBasicPosition(value);
  }

  componentDidUpdate(prevProps) {
    const { isOpen, value } = this.props;
    if (prevProps.value !== value || (isOpen && !prevProps.isOpen)) {
      this.setBasicPosition(value);
    }
  }

  setBasicPosition = value => {
    this.elmScrollTop(this.hourElement, value ? value.hour() : 0);
    this.elmScrollTop(this.minuteElement, value ? value.minute() : 0);
    this.elmScrollTop(this.secondElement, value ? value.second() : 0);
  };

  selectTime = (type, time, disabled) => {
    if (!disabled) {
      const { onValueChange, value = moment() } = this.props;
      const newValue = moment(value)[type](time);
      this.elmScrollTop(this[`${type}Element`], time);
      onValueChange && onValueChange(newValue, { type, time });
    }
  };

  elmScrollTop = (element, time) => {
    if (element) {
      const { itemHeight } = this.props;
      const targetPosition = itemHeight * time;
      let scrollTop = targetPosition > 0 ? targetPosition : 0;
      const maxScrollTop = element.scrollHeight - element.clientHeight;
      if (scrollTop >= maxScrollTop) {
        scrollTop = maxScrollTop;
      }
      slideTo({
        beginValue: element.scrollTop,
        endValue: scrollTop,
        time: 300,
        tweenName: 'easeInSine',
        stepCallback: value => {
          element.scrollTop = value;
        },
        // endCallback: callback,
      });
      return scrollTop;
    }
  };

  getHourElement = el => {
    this.hourElement = el;
  };

  getMinuteElement = el => {
    this.minuteElement = el;
  };

  getSecondElement = el => {
    this.secondElement = el;
  };

  disabledHoursCondition = hour => {
    const { disabledHours, value = moment() } = this.props;
    return disabledHours && disabledHours(value, hour);
  };

  disabledMinutesCondition = minute => {
    const { disabledMinutes, value = moment() } = this.props;
    return disabledMinutes && disabledMinutes(value, value.hour(), minute);
  };

  disabledSecondsCondition = second => {
    const { disabledSeconds, value = moment() } = this.props;
    return disabledSeconds && disabledSeconds(value, value.hour(), value.minute(), second);
  };

  render() {
    const { value, prefixCls } = this.props;
    return (
      <div className={`${prefixCls}-body`}>
        {[
          {
            ref: this.getHourElement,
            checked: value ? value.hour() : null,
            type: 'hour',
            optionsList: easyToMap(24),
            disabledFunc: this.disabledHoursCondition,
          },
          {
            ref: this.getMinuteElement,
            checked: value ? value.minute() : null,
            type: 'minute',
            optionsList: easyToMap(60),
            disabledFunc: this.disabledMinutesCondition,
          },
          {
            ref: this.getSecondElement,
            checked: value ? value.second() : null,
            type: 'second',
            optionsList: easyToMap(60),
            disabledFunc: this.disabledSecondsCondition,
          },
        ].map(renderOption => {
          const { ref, checked, type, optionsList, disabledFunc } = renderOption;
          return (
            <div className={`${prefixCls}-cell`} ref={ref} key={type}>
              {optionsList.map(item => {
                const classes = classNames(`${prefixCls}-item`, {
                  [`${prefixCls}-item-checked`]: item === checked,
                });
                let disabled = false;
                if (disabledFunc(item)) {
                  disabled = true;
                }
                return (
                  <Button
                    variant="text"
                    className={classes}
                    key={item}
                    disabled={disabled}
                    onClick={element => this.selectTime(type, item, disabled, element)}>
                    {item}
                  </Button>
                );
              })}
              <div className={`${prefixCls}-cell-padding`} />
            </div>
          );
        })}
      </div>
    );
  }
}

export default TimePanel;



// WEBPACK FOOTER //
// ./src/timePicker/TimePanel.jsx